/**
 *
 * Asynchronously loads the component for PreSessionAssessment
 *
 */

import loadable from '@loadable/component';

export default loadable(() => import('./index'));
